<pcg-resizable-widget>
    <!-- #region Header -->
    <span widget-title>SUPPORT TICKETS</span>
    <div widget-meta>
        <button 
            class="btn-primary"
            (click)="createNewTicket()"
        >
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M8 1v14M1 8h14"/></svg>
            New Ticket
        </button>
    </div>
    <!-- #endregion -->

    <!-- #region Body -->
    <div class="widget-body h-100" widget-body>
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Tickets...
            </div> 
        } @else {
            @for (supportTicket of supportTickets(); track supportTicket) {
                <div 
                    class="notif-item" 
                    (click)="redirectToTicket(supportTicket);"
                >
                    <div class="notif-body">
                        <div class="notif-title">#{{ supportTicket.supportTicketId }}</div>
                        <div class="notif-desc">{{ supportTicket.subject }}</div>
                    </div>
                    <div class="notif-right mt-1">
                        <div class="blue-pill rounded-pill">{{ supportTicket.status }}</div>
                    </div>
                </div>
            } @empty {
                <div class="text-center text-muted py-3">No notifications to display</div>
            }
        }
    </div>
    <!-- #endregion -->
</pcg-resizable-widget>